import { render, staticRenderFns } from "./IconMoveVertical.vue?vue&type=template&id=ed1d4130"
import script from "./IconMoveVertical.vue?vue&type=script&lang=js"
export * from "./IconMoveVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports